import * as React from "react";
import { Link, useHistory } from "react-router-dom";

import { useSeo } from "../../hooks";

const Downloads: React.FunctionComponent = () => {
    const history = useHistory();

    useSeo({
        title: "Play Oberin - Official Game Downloads",
        description:
            "Download and play Oberin on Mac (Intel), Mac (Apple Silicon), and Windows 8.1, 10, and 11.",
        canonical: "https://www.oberin.be/download",
        robots: "index,follow",
        ogImage: "https://www.oberin.be/logo512.png",
        twitterCard: "summary_large_image",
    });

    const handleTermsOfServiceClicked = (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
        event.preventDefault();
        history.push("/termsOfService");
    };

    return (
        <div className="w-100 px-2">
            <div className="box-shadow">
                <div className="title-bar px-2">
                    <h1 className="mb-0 title-bar-heading">Play the game</h1>
                </div>
                <div className="bg-light-gray p-2 bl-xs br-xs bb-xs d-flex flex-column">
                    <p>
                        Choose your platform below and launch straight into
                        Oberin.
                    </p>
                    <div className="row">
                        <div className="col-12 col-md-6 mb-2">
                            <a
                                href="https://drive.google.com/file/d/1SkGgfUS6FGcPnsm3GYc5rCXz5zhNUFDB/view?usp=sharing"
                                className="btn dark-red-button text-normal rounded-0 w-100 text-white d-block text-center p-2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Mac (Intel)
                            </a>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                            <a
                                href="https://drive.google.com/file/d/1jg4PEbOFY_GXVx-Jg7xasYAeDFRrWmtj/view?usp=sharing"
                                className="btn dark-red-button text-normal rounded-0 w-100 text-white d-block text-center p-2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Mac (Apple Silicon)
                            </a>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                            <a
                                href="https://oberin.be/attachments/downloads/Oberin Windows.zip"
                                className="btn dark-red-button text-normal rounded-0 w-100 text-white d-block text-center p-2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Windows 10 and 11
                            </a>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                            <a
                                href="https://oberin.be/attachments/downloads/Oberin Windows 8_1.zip"
                                className="btn dark-red-button text-normal rounded-0 w-100 text-white d-block text-center p-2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Windows 8.1
                            </a>
                        </div>
                    </div>
                    <p className="mt-1 mb-0">
                        Need help getting started or have issues in-game? Join
                        the official Discord community or use{" "}
                        <strong>/help</strong> in game to contact a Game Master.
                    </p>
                </div>
            </div>

            <div className="mt-2 box-shadow">
                <div className="title-bar px-2">
                    <span>Character and account information</span>
                </div>
                <div className="bg-light-gray p-2 bl-xs br-xs bb-xs d-flex flex-column">
                    <p>
                        Your account and character are created through the game
                        client itself. Launch the game, then follow the prompts
                        to create your account and first character.
                    </p>
                    <p>
                        <strong>Character name rules:</strong> use a proper
                        fantasy-style name. Do not use offensive language,
                        titles, sentences, animal or monster names, or anything
                        that may imply you are Oberin staff. Character approval
                        is handled by Game Masters.
                    </p>
                    <p className="mb-0">
                        By playing, you agree to Oberin privacy and terms. Read
                        the full policy in the{" "}
                        <Link
                            to="/termsOfService"
                            className="text-dark-red"
                            onClick={handleTermsOfServiceClicked}
                        >
                            Terms of Service
                        </Link>
                        .
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Downloads;
